/**
 * @desc getTransportTODetailByWaybillNo
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.TransportToDetailDto>>;
export function request(
  params: API.tms.transportToDetailFacadeImpl.getTransportTODetailByWaybillNo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/getTransportTODetailByWaybillNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
